import { todayLocal } from './time.js';
/* --------------------------------------------------------------------------
   Verktyg
   -------------------------------------------------------------------------- */

/** Escapar text innan den läggs in i DOM via innerHTML. */
export function esc(v){
  return String(v ?? '')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

export const nf0 = new Intl.NumberFormat('sv-SE',{maximumFractionDigits:0});
export const nf1 = new Intl.NumberFormat('sv-SE',{minimumFractionDigits:1,maximumFractionDigits:1});
export function kr(v){
  if(!isFinite(v)) return '–';
  return nf0.format(Math.round(v)) + ' kr';
}
export function pct(v){
  if(!isFinite(v)) return '–';
  return nf1.format(v).replace('.',',') + ' %';
}
/** Antal kan vara decimalt (t.ex. timmar). Visa decimal bara när det behövs. */
export function qty(v){
  if(!isFinite(v)) return '–';
  return Math.abs(v % 1) < 0.005 ? nf0.format(Math.round(v)) : nf1.format(v);
}
export function num(v){ return isFinite(v) ? nf0.format(v) : '–'; }

/** Division som aldrig ger NaN eller Infinity. */
export function div(a,b){ return (b && isFinite(a/b)) ? a/b : 0; }

/** "2026-03-12T17:31:05" -> "2026-03-12". Ingen Date, alltså ingen tidszonsrisk. */
export const dayOf   = ts => String(ts).slice(0,10);
export const monthOf = ts => String(ts).slice(0,7);
export const hourOf  = ts => parseInt(String(ts).slice(11,13),10);

/** Veckodag måndag=0 … söndag=6, beräknad från datumsträngen. */
export function weekdayOf(ts){
  const [y,m,d] = String(ts).slice(0,10).split('-').map(Number);
  const js = new Date(Date.UTC(y, m-1, d)).getUTCDay(); // 0=sön
  return (js + 6) % 7;
}

export function fmtDate(iso){
  const [y,m,d] = String(iso).slice(0,10).split('-').map(Number);
  if(!y) return '–';
  const months = ['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'];
  return `${d} ${months[m-1]} ${y}`;
}
export function fmtMonth(ym){
  const [y,m] = String(ym).split('-').map(Number);
  const months = ['januari','februari','mars','april','maj','juni','juli','augusti','september','oktober','november','december'];
  return `${months[m-1]} ${y}`;
}
/** Dagens datum i svensk tid, samma tidszon som kvittona visas i. */
export function todayISO(){
  return todayLocal();
}

export function marginPill(m){
  if(!isFinite(m)) return '–';
  const cls = m >= 40 ? 'pill-good' : m >= 15 ? 'pill-mid' : 'pill-low';
  return `<span class="pill ${cls}">${esc(pct(m))}</span>`;
}
export function signed(v, fmt){
  const t = fmt(v);
  if(v < 0) return `<span class="neg">${esc(t)}</span>`;
  return esc(t);
}
